import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { RouterModule, Routes } from '@angular/router';

import { MwCoreToolbarModule } from 'app/@shared/@components/core-toolbar/core-toolbar.module';
import { MwDialogModule } from 'app/@shared/@components/dialog';
import { MwFormModule } from 'app/@shared/@components/form';
import { MwPhoneInputModule } from 'app/@shared/@components/phone-input/phone-input.module';
import { MwSelectModule } from 'app/@shared/@components/select/select.module';
import { MwSharedDirectivesModule } from 'app/@shared/@directives/directives.module';
import { UserProfileApiService } from './user-profile-api.service';
import { UserProfileCheckService } from './user-profile-check.service';
import { UserProfileComponent } from './user-profile.component';

const routes: Routes = [
  {
    path: '',
    component: UserProfileComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MwCoreToolbarModule,
    TranslateModule,
    RouterModule.forChild(routes),
    MwFormModule,
    MatIconModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    ReactiveFormsModule,
    MwSelectModule,
    MwPhoneInputModule,
    MatLegacyButtonModule,
    MwSharedDirectivesModule,
    MwCoreToolbarModule,
    MwDialogModule,
  ],
  exports: [],
  declarations: [UserProfileComponent],
  providers: [UserProfileApiService, UserProfileCheckService],
})
export class UserProfileModule {}
